import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroCentroCusto from '../../actions/centro-custo/adicionarFiltroCentroCusto'
import removerFiltroCentroCusto from '../../actions/centro-custo/removerFiltroCentroCusto'
import {
    FILTRO_CENTRO_CUSTO_USUARIO,
    FILTRO_DATA_ENTRADA_CENTRO_CUSTO,
    FILTRO_DATA_OCORRENCIA_CENTRO_CUSTO,
    FILTRO_TIPOS_OCORRENCIA_CENTRO_CUSTO,
} from '../../util/filtros'
import FiltroBuscaCentroCusto from './FiltroBuscaCentroCusto'
import FiltroChaveValor from '../comum/FiltroChaveValor';

export class FiltroCentroCusto extends Component {

    adicionarFiltro (filtro) {
        this.props.adicionarFiltroCentroCusto(filtro)
    }

    removerFiltro (filtro) {
        this.props.removerFiltroCentroCusto(filtro)
    }

    render() {
        return (
            <React.Fragment>
                <div className="conteudo">
                    <FiltroBuscaCentroCusto
                        filtro={FILTRO_CENTRO_CUSTO_USUARIO}
                        opcoes={[]}
                        isNome={true}
                    />

                    <FiltroChaveValor
                        filtro={FILTRO_TIPOS_OCORRENCIA_CENTRO_CUSTO}
                        opcoes={this.props.tiposOcorrenciaCentroCusto}
                        filtrosAdicionados={this.props.filtrosAdicionados}
                        adicionarFiltro={this.adicionarFiltro.bind(this)}
                        removerFiltro={this.removerFiltro.bind(this)}
                    />

                    <FiltroBuscaCentroCusto
                        filtro={FILTRO_DATA_ENTRADA_CENTRO_CUSTO}
                        opcoes={[new Date().getFullYear()]}
                        isFiltroData={true}
                    />
                    <FiltroBuscaCentroCusto
                        filtro={FILTRO_DATA_OCORRENCIA_CENTRO_CUSTO}
                        opcoes={[new Date().getFullYear()]}
                        isFiltroData={true}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export const mapStateToProps = (state) => ({
    empresaSelecionada: state.empresaSelecionada,
    filtrosAdicionados: state.filtrosAdicionadosCentroCusto,
    tiposOcorrenciaCentroCusto: state.centroCusto.tiposCentroCusto || [],

  })

  export const mapDispatchToProps = dispatch => (
    bindActionCreators({
      adicionarFiltroCentroCusto,
      removerFiltroCentroCusto
    }, dispatch)
  )

  export default connect(mapStateToProps, mapDispatchToProps)(FiltroCentroCusto)
